module.exports = __webpack_public_path__ + "img/strength_video_splash.2ba86306.jpg";